import axios from 'axios';

// REACT_APP_API_URL is inlined at BUILD time by CRA. It MUST be set in
// Coolify's build env for App 2, otherwise this falls back to /api.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api`
    : '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mcusa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mcusa_token');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
